// tslint:disable
export var AccountType;
(function (AccountType) {
    // PAT
    AccountType[AccountType["PATIENT"] = 1] = "PATIENT";
    // PRESCRIBER
    AccountType[AccountType["PRESCRIBER"] = 2] = "PRESCRIBER";
    // SITE
    AccountType[AccountType["SITE"] = 3] = "SITE";
})(AccountType || (AccountType = {}));
//# sourceMappingURL=AccountType.js.map